import style from "./block.module.scss";
import React from "react";
import { useSpring, a } from 'react-spring';
import {ReactComponent as Arrow} from "../assets/arrow_right.svg";

function Block({height, width, category, image, url, title, extract, readMore="Lire la suite", fade=false}) {
    const {opacity} = useSpring({
        from: { opacity: fade ? 0 : 1 },
        to: { opacity: 1 },
    });

    return <a.div className={category ? style.block : style.noCategory} style={{backgroundImage: `url(${image})`, height:height, width:width, opacity}}>
            <div className={style.category}>
                {category}
            </div>
            <div className={style.bottom}>
                <div className={style.title}>{title}</div>
                <div className={style.extract}>{extract}</div>
                <a className={style.link} href={url}><span>{readMore}</span> <Arrow/></a>
            </div>
    </a.div>;
}

export default Block;
